import {
  EMPTY_STRING,
  globalConstants,
  initialPagination,
  paymentHistoryConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const { GET_PAYMENT_HISTORY, PAYMENT_HISTORY_PAGINATION } =
  paymentHistoryConstants;

const initialState = {
  paymentHistory: [],
  pagination: {
    ...initialPagination,
    role: EMPTY_STRING,
    plan: EMPTY_STRING,
    planType: EMPTY_STRING,
  },
};

export const paymentHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_HISTORY + SUCCESS:
      return {
        ...state,
        paymentHistory: action.data.items,
        pagination: {
          ...state.pagination,
          total: action.data.total,
        },
      };
    case PAYMENT_HISTORY_PAGINATION:
      return { ...state, pagination: action.data };
    default:
      return { ...state };
  }
};
